<!--
  ~ Copyright (c) 2023 D2ArmorPicker by Mijago.
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published
  ~ by the Free Software Foundation, either version 3 of the License, or
  ~ (at your option) any later version.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program.  If not, see <http://www.gnu.org/licenses/>.
  -->

<div class="changelog-container">
  <ng-container
    *ngFor="let log of displayedChangelogData; trackBy: trackByVersion; let isFirst = first">
    <mat-card class="version-card" [class.latest-version]="isFirst">
      <mat-card-header class="version-header">
        <div class="version-info">
          <mat-card-title class="version-title">
            <mat-icon class="version-icon">new_releases</mat-icon>
            <span class="version-number">v{{ log.version }}</span>
            <mat-chip class="latest-badge" *ngIf="isFirst" color="accent">Latest</mat-chip>
          </mat-card-title>
          <mat-card-subtitle class="release-date">
            <mat-icon class="date-icon">schedule</mat-icon>
            Released {{ log.date }}
          </mat-card-subtitle>
        </div>
      </mat-card-header>

      <mat-card-content class="changelog-content">
        <mat-list class="entries-list" dense>
          <ng-container *ngFor="let entry of log.entries; trackBy: trackByEntry">
            <mat-list-item class="changelog-entry" [class]="getEntryClass(entry.type)">
              <mat-icon
                matListItemIcon
                class="entry-icon"
                [class]="getIconClass(entry.type)"
                [matTooltip]="getTooltipText(entry.type)"
                [attr.aria-label]="getTooltipText(entry.type)">
                {{ getEntryIcon(entry.type) }}
              </mat-icon>

              <div matListItemTitle class="entry-content">
                <div class="entry-text">{{ entry.text }}</div>
                <div class="entry-issues" *ngIf="entry.issues && entry.issues.length > 0">
                  <mat-chip-listbox class="issues-list" aria-label="Related Issues">
                    <mat-chip-option
                      *ngFor="let issue of entry.issues"
                      class="issue-chip"
                      [selectable]="false"
                      [value]="issue">
                      <mat-icon class="issue-icon">bug_report</mat-icon>
                      {{ issue }}
                    </mat-chip-option>
                  </mat-chip-listbox>
                </div>
              </div>
            </mat-list-item>
          </ng-container>
        </mat-list>
      </mat-card-content>
    </mat-card>
  </ng-container>
</div>
